import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import { pxToRem } from '../../../../../styles/utils';
import { featureToggle } from '../../../../../constants/common';

interface Banner1Props {
  src: string;
  alt: string;
  onClick?: Function;
}

export default function Banner1(props: Banner1Props) {
  const { src, alt, onClick } = props;
  return (
    <BannerWrapper>
      <StyledCard onClick={(e) => featureToggle.BANNER_CTA && onClick(e)} showPointer={featureToggle.BANNER_CTA}>
        <Image src={src} alt={alt} />
      </StyledCard>
    </BannerWrapper>
  );
}

const BannerWrapper = styled.article`
  width: 100%;
  height: 100%;
  margin-left: ${pxToRem(5)};
  ${up('md')} {
    margin-left: ${pxToRem(3)};
  }
`;

const Image = styled.img`
  width: 100%;
  height: 20%;
  max-width: 600px;
  border-radius: ${pxToRem(8)};
  max-height: ${pxToRem(124)};
  margin-right: ${pxToRem(8)};
  ${up('md')} {
    width: 95%;
    // margin-right: 0;
    margin:auto;
    max-height: ${pxToRem(170)};
  }
`;

const StyledCard = styled.div<{ showPointer: boolean }>`
  border-radius: ${pxToRem(8)};
  cursor: ${(props) => (props.showPointer ? 'pointer' : 'normal')};
`;
